import {HttpHeaders} from '@angular/common/http';
import {Configuration, Entry, GetAttributeListResponse, GetAttributeResponse, Response, SettingsServiceInterface} from '@gt-api';
import {MockData} from '@testhelper/mock-data';
import {Observable, of} from 'rxjs';

export class SettingsServiceStub implements SettingsServiceInterface {
  static returnCode = 200;
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getDepartmentAttributeList1(
    key: string,
    organization?: string,
    departmentId?: number,
    appId?: string
  ): Observable<GetAttributeListResponse> {
    return of({code: SettingsServiceStub.returnCode, entries: MockData.getSmsTemplates()});
  }

  getDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string): Observable<GetAttributeResponse> {
    return of({code: SettingsServiceStub.returnCode});
  }

  getUserAttribute1(key: string, organization?: string, login?: string, appId?: string): Observable<GetAttributeResponse> {
    return of({code: SettingsServiceStub.returnCode});
  }

  getUserAttributeList1(key: string, organization?: string, login?: string, appId?: string): Observable<GetAttributeListResponse> {
    return of({code: SettingsServiceStub.returnCode});
  }

  setDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, body?: string): Observable<Response> {
    return of({code: SettingsServiceStub.returnCode});
  }

  setDepartmentAttributeList1(
    key: string,
    organization?: string,
    departmentId?: number,
    appId?: string,
    body?: Array<Entry>
  ): Observable<Response> {
    return of({code: SettingsServiceStub.returnCode});
  }

  setUserAttribute1(key: string, organization?: string, login?: string, appId?: string, body?: string): Observable<Response> {
    return of({code: SettingsServiceStub.returnCode});
  }

  setUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, body?: Array<Entry>): Observable<Response> {
    return of({code: SettingsServiceStub.returnCode});
  }
}
